import { GET_OPTIONALS_BY_SUB_LOT, ERASE_OPTIONALS_BY_SUB_LOT, ERASE_OPTIONALS, ADD_OPTIONALS_BY_SUB_LOT, REMOVE_OPTIONALS_BY_SUB_LOT, PUSH_OPTIONALS_BY_SUB_LOT, LOAD_OPTIONALS_STORE_BY_LOT } from '../../actions/types';

const initialState = {

}

export default (state = initialState, action) => {
  switch (action.type) {

    case GET_OPTIONALS_BY_SUB_LOT:
      return Object.assign({}, state, {
        ...action.payload
      });
    case ADD_OPTIONALS_BY_SUB_LOT:
      return Object.assign({}, state, {
        ...action.payload
      });

    case LOAD_OPTIONALS_STORE_BY_LOT:

      return Object.assign({}, state, {
        ...action.payload
      });

    case PUSH_OPTIONALS_BY_SUB_LOT:

      const newObj = JSON.parse(JSON.stringify(state));
      if (!newObj.hasOwnProperty(action.payload.subLotId)) {
        newObj[action.payload.subLotId] = [];
      }
      newObj[action.payload.subLotId].push(action.payload.optionalId);

      return Object.assign({}, state,
        newObj
      );

    case ERASE_OPTIONALS:
      return Object.assign({}, {}
      );

    case ERASE_OPTIONALS_BY_SUB_LOT:
      const stateForOptionalsDeletion = JSON.parse(JSON.stringify(state));
      delete stateForOptionalsDeletion[action.payload];
      return stateForOptionalsDeletion;
    case REMOVE_OPTIONALS_BY_SUB_LOT:

      const newState = JSON.parse(JSON.stringify(state));
      newState[action.payload.subLotId] = newState[action.payload.subLotId].filter((oItem) => {
        return oItem !== action.payload.optionalId;
      });

      return Object.assign({}, state,
        newState
      );

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/carOptionals/carOptionalsReducer.js